import { GuestInfo } from '@models/guest-info.model';
import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { Injectable } from '@angular/core';
import { formatPhoneWithCountryCode } from './phone-format';

@Injectable({
  providedIn: 'root'
})
export class GuestInfoService {
  constructor() {}

  /**
   * Create GuestInfo object from Booking
   * Always contains both user and booking data - display mode is handled by component
   * @param booking Booking object from API
   * @returns GuestInfo object with properly formatted data
   */
  createGuestInfo(booking?: IBookingModel): GuestInfo {
    if (!booking) {
      return {
        name: 'Unknown Guest',
        email: '',
        phone: ''
      };
    }
    const userName = booking.user?.name || booking.name || '';
    const userEmail = booking.user?.email || booking.email_address || '';
    const checkinPhone = booking.phone_number ? '' : this.resolveCheckinPhone(booking);
    const userPhone = booking.phone_number || checkinPhone;
    return {
      id: booking.user?.id,
      name: userName,
      email: userEmail,
      phone: userPhone,
      phoneSource: booking.phone_number ? 'booking' : checkinPhone ? 'checkin' : undefined,
      lastAppLogin: booking.user?.last_login ? new Date(booking.user.last_login) : undefined,
      bookingName: booking.name || undefined,
      bookingEmail: booking.email_address || undefined,
      bookingPhone: booking.phone_number || undefined
    };
  }

  /**
   * Phone number the guest gave at check-in (embedded checkin object only, IRI is ignored).
   * Used as fallback when the booking channel (e.g. Booking.com) provides no phone number.
   */
  private resolveCheckinPhone(booking: IBookingModel): string {
    const checkin = booking.checkin;
    if (!checkin || typeof checkin === 'string') return '';
    return formatPhoneWithCountryCode(checkin.phone_number, checkin.country_code);
  }
}
